import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRelations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path d="M11.939 3.109c0 .654-.537 1.185-1.2 1.185s-1.2-.53-1.2-1.185.537-1.186 1.2-1.186 1.2.531 1.2 1.186M5.514 17.318c0 .654-.538 1.185-1.2 1.185-.663 0-1.2-.53-1.2-1.185s.537-1.186 1.2-1.186 1.2.531 1.2 1.186" />
    <path
      fillRule="evenodd"
      d="M7.66 3.978A1 1 0 0 1 6.8 5.1c-.382.05-.916.223-1.28.52-.305.246-.487.556-.37 1.107.005.025.037.122.202.283s.418.339.77.526c.705.376 1.666.713 2.724.997.521.14 1.118.265 1.771.403l.666.142c.89.192 1.845.414 2.689.713.82.291 1.674.7 2.246 1.341.3.337.53.748.624 1.236.093.487.036.984-.137 1.475-.339.956-1.27 1.67-2.543 2.234-1.313.581-3.206 1.098-5.825 1.53a1 1 0 1 1-.326-1.974c2.545-.42 4.25-.901 5.341-1.384 1.13-.5 1.411-.916 1.467-1.073.077-.218.074-.353.059-.433a.6.6 0 0 0-.154-.28c-.226-.254-.684-.525-1.42-.786-.713-.253-1.558-.453-2.442-.644q-.305-.066-.615-.13c-.667-.142-1.34-.284-1.919-.439-1.12-.3-2.248-.684-3.147-1.163-.45-.24-.877-.521-1.221-.856s-.652-.765-.766-1.302c-.296-1.392.268-2.429 1.064-3.076.737-.599 1.658-.868 2.28-.95a1 1 0 0 1 1.123.86Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRelations;
